<template>
  <div class="padded" style="clear: both;">

    <invoice-summary />

    <el-row :gutter="gutter">
      <el-col align="center" :span="24">
        <xolas-table
          title="Financial Statement"
          url="report/finance/summary"
          table-ref="finance-summary"
          :show-search="false"
          :show-refresh="true"
          track-by="name"
          :fields="fields"
          />
      </el-col>
    </el-row>

  </div>
</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'

import InvoiceSummary from '@/components/dashboard/finance/InvoiceSummary'

export default {

  mixins: [SiteMixins],

  components: {
    InvoiceSummary
  },

  data () {
    return {
      gutter: 16,
      // minWidth hints mirror the pre-migration vuetable-2 render, measured at
      // 1504px viewport (.context/xol-234-baselines/metrics.json,
      // statement-view[0]) — el-table distributes un-sized columns equally,
      // which does not match the legacy content-based auto layout.
      fields: [
        {
          name: 'name',
          title: 'Company',
          minWidth: 386
        },
        {
          name: 'category',
          title: 'Invoice Type',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: 146
        },
        {
          name: 'ledger',
          title: 'Ledger',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: 84
        },
        {
          name: 'subtotal',
          title: 'Sub-Total',
          callback: this.formatInteger,
          visible: this.showTax(),
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: 113
        },
        {
          name: 'tax',
          title: this.taxLabel || 'Tax',
          callback: this.formatInteger,
          visible: this.showTax(),
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: 40
        },
        {
          name: 'total',
          title: 'TOTAL',
          titleClass: 'text-primary',
          dataClass: 'text-primary',
          callback: this.formatInteger,
          minWidth: 76
        },
        {
          name: 'totalPaid',
          title: 'Paid',
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down text-success',
          dataClass: 'hidden-md-and-down text-success',
          minWidth: 51
        },
        {
          name: 'outstanding',
          title: 'O/S',
          callback: this.formatInteger,
          titleClass: 'hidden-sm-and-down text-warning',
          dataClass: 'hidden-sm-and-down text-warning',
          minWidth: 49
        }
      ]
    }
  }
}

</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
